import { render } from "./CompanySearch.vue?vue&type=template&id=4862fa70&scoped=true"
import script from "./CompanySearch.vue?vue&type=script&lang=js"
export * from "./CompanySearch.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=4862fa70&scoped=true&lang=css&external"
import "./CompanySearch.vue?vue&type=style&index=1&id=4862fa70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4862fa70"]])

export default __exports__